import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";
import { withOptionalTooltip } from "../interface/Tooltip";

const ToolbarIconButton = props => {
  const btn = (
    <div
      id={props.id ? props.id : null}
      className={`toolbarIconBtn ${props.disabled ? "disabled" : ""} ${props.active ? "active" : ""}`}
      onClick={props.disabled || !props.onClick ? null : () => props.onClick()}
    >
      <Icon
        icon={props.icon}
        color={props.color ? props.color : props.active ? "iconActive" : props.editMode ? "iconOnActive" : "iconMono"}
        pulse={props.pulse}
      />
      {props.label ? <div className="toolbarIconBtn">props.label</div> : null}
    </div>
  );

  return withOptionalTooltip(btn, props.tooltip, { placement: "bottom-start" });
};

ToolbarIconButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  editMode: PropTypes.bool,
  pulse: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  tooltip: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string
};

export default ToolbarIconButton;
